import { getCoachPageUrl } from 'constants/pages';
import { toTitleCase } from 'utils/shared/toTitleCase';
import { getProfileImageUrlOrPlaceholder } from 'utils/shared/user/getProfileImageUrlOrPlaceholder';
import { CoachAvatarProps } from 'screens/PlayerLoggedInScreen/props';
import Button from 'components/Button';
import Link from 'components/Link';

const CoachAvatar: React.FC<CoachAvatarProps> = ({ coach, onBook }) => {
  return (
    <div className="flex">
      <div className="flex w-full flex-col items-center justify-center gap-ds-md">
        <Link href={getCoachPageUrl(coach.username || coach.id)}>
          <img
            src={getProfileImageUrlOrPlaceholder({ path: coach.profileImagePath })}
            className="h-[6.5rem] w-[6.5rem] rounded-full object-cover object-top max-sm:h-[5.5rem] max-sm:w-[5.5rem]"
          />
        </Link>
        <Link
          href={getCoachPageUrl(coach.username || coach.id)}
          className="w-full truncate text-center"
        >
          <span className="max-sm:typography-product-card-title typography-product-card-title-desktop">
            {toTitleCase(coach?.fullName || '')}
          </span>
        </Link>
        <Button
          variant="primary"
          sizeDesktop="md"
          sizeMobile="sm"
          className="w-fit"
          onClick={() => onBook(coach.id)}
        >
          Book
        </Button>
      </div>
    </div>
  );
};

export default CoachAvatar;
